// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var Github      = require("./github");
var Caml_array  = require("bs-platform/lib/js/caml_array.js");
var Json_decode = require("bs-json/lib/js/src/json_decode.js");

function owner(json) {
  return /* record */[
          /* id */Json_decode.field("id", Json_decode.$$int, json),
          /* login */Json_decode.field("login", Json_decode.string, json),
          /* owner_type */Json_decode.field("type", Json_decode.string, json),
          /* avatar_url */Json_decode.field("avatar_url", Json_decode.string, json)
        ];
}

function subject(json) {
  return /* record */[
          /* title */Json_decode.field("title", Json_decode.string, json),
          /* url */Json_decode.field("url", Json_decode.string, json),
          /* latest_comment_url */Json_decode.field("latest_comment_url", Json_decode.string, json),
          /* subject_type */Json_decode.field("type", Json_decode.string, json)
        ];
}

function repository(json) {
  return /* record */[
          /* full_name */Json_decode.field("full_name", Json_decode.string, json),
          /* html_url */Json_decode.field("html_url", Json_decode.string, json),
          /* id */Json_decode.field("id", Json_decode.$$int, json),
          /* name */Json_decode.field("name", Json_decode.string, json),
          /* private */Json_decode.field("private", Json_decode.bool, json),
          /* owner */Json_decode.field("owner", owner, json)
        ];
}

function notification(json) {
  return /* record */[
          /* id */Json_decode.field("id", Json_decode.string, json),
          /* unread */Json_decode.field("unread", Json_decode.bool, json),
          /* reason */Json_decode.field("reason", Json_decode.string, json),
          /* updated_at */Json_decode.field("updated_at", Json_decode.string, json),
          /* subject */Json_decode.field("subject", subject, json),
          /* repository */Json_decode.field("repository", repository, json)
        ];
}

function notifications(json) {
  return Json_decode.array(notification, json);
}

var Decode = /* module */[
  /* owner */owner,
  /* subject */subject,
  /* repository */repository,
  /* notification */notification,
  /* notifications */notifications
];

function last(arr) {
  var len = arr.length;
  return Caml_array.caml_array_get(arr, len - 1 | 0);
}

function githubUrl(notification) {
  var arr = notification[/* subject */4][/* url */1].split("/");
  var l = last(arr);
  var match = notification[/* subject */4][/* subject_type */3];
  switch (match) {
    case "Issue" : 
        return notification[/* repository */5][/* html_url */1] + ("/issues/" + l);
    case "PullRequest" : 
        return notification[/* repository */5][/* html_url */1] + ("/pull/" + l);
    default:
      return "";
  }
}

function fetchNotifications(token) {
  return Github.notifications(token).then((function (jsonText) {
                console.log(JSON.parse(jsonText));
                var json = JSON.parse(jsonText);
                return Promise.resolve(Json_decode.array(notification, json));
              }));
}

function markAsRead(token, notification) {
  return Github.readNotification(token, notification[/* id */0]);
}

exports.Decode             = Decode;
exports.last               = last;
exports.githubUrl          = githubUrl;
exports.fetchNotifications = fetchNotifications;
exports.markAsRead         = markAsRead;
/* Github Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/notifications.re
// module id = 56
// module chunks = 0